export default [
  {
    title: 'Workflow',
    icon: 'paper-plane',
    route: 'Workflows',
    resource: 'Workflows',
  },
]
